import { SearchIndex } from 'emoji-mart';
import { Editor } from 'slate';
import MenuItemComponent from './components/MenuItemComponent';
import MenuPluginFactory from '../MenuPluginFactory/MenuPluginFactory';
import '@aha-app/aha-shared/withEmoji';

export interface ReferenceEmojiObject {
  id: string;
  skins: { native: string; shortcodes: string }[];
}

const ReferenceEmojiPlugin = MenuPluginFactory<ReferenceEmojiObject>({
  name: 'emoji-reference',
  triggerCharacter: ':',
  menuItemUniqueKey: 'id',
  minCharacters: 2,
  onSearch: async ({ text, controller }) => {
    text = text.toLowerCase().trim();
    return await SearchIndex.search(text);
  },
  MenuItemComponent,
  onSelect: ({ item, editor, controller }) => {
    Editor.insertText(editor, `${item.skins[0].native} `);
  },
});

export default [ReferenceEmojiPlugin];
